import { isString, size } from 'lodash';

import {
  MISSING_MANAGER_FULL_NAME,
  UNKNOWN_CLIENT_FULL_NAME,
  UNKNOWN_MANAGER_FULL_NAME,
} from '../../consts/persons';

export const serializeContactName = (
  unparsedName,
  unparsedPhone,
  personType
) => {
  let parsedName;
  const phoneExist = isString(unparsedPhone) && size(unparsedPhone);
  if (isString(unparsedName) && size(unparsedName)) {
    if (personType === 'manager' && phoneExist) {
      parsedName = `${unparsedName} (#${unparsedPhone})`;
    } else {
      parsedName = unparsedName;
    }
  } else if (phoneExist) {
    parsedName = unparsedPhone;
  } else {
    parsedName = UNKNOWN_CLIENT_FULL_NAME;
  }

  return parsedName;
};

export const serializeManagerName = (
  entityType,
  unparsedId,
  unparsedName,
  isIncoming
) => {
  let parsedName;
  if (isString(unparsedName) && size(unparsedName)) {
    parsedName = unparsedName;
  } else {
    switch (entityType) {
      case 'call': {
        if (isIncoming) {
          parsedName = isString(unparsedId)
            ? UNKNOWN_MANAGER_FULL_NAME
            : MISSING_MANAGER_FULL_NAME;
        } else {
          parsedName = UNKNOWN_MANAGER_FULL_NAME;
        }

        break;
      }

      case 'email':
      case 'note':
      default:
        parsedName = UNKNOWN_MANAGER_FULL_NAME;
        break;
    }
  }

  return parsedName;
};
